/* eslint-disable react/jsx-no-undef */
import React, { useState } from "react";
import { db, auth } from "../firebase";
import { collection, addDoc, Timestamp } from "firebase/firestore";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import {
  FaUpload,
  FaUser,
  FaSchool,
  FaPhone,
  FaCalendarAlt,
  FaIdCard,
  FaFilePdf,
  FaTrash,
} from "react-icons/fa";
import imageCompression from "browser-image-compression";

export default function Pendaftaran() {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    nama: "",
    nisn: "",
    tempat_lahir: "",
    tanggal_lahir: "",
    jenis_kelamin: "",
    asal_sekolah: "",
    alamat: "",
    nilai_rata: "",
    telepon: "",
    nama_ayah: "",
    nama_ibu: "",
    pekerjaan_ayah: "",
    pekerjaan_ibu: "",
    pendidikan_ayah: "",
    pendidikan_ibu: "",
  });

  const [files, setFiles] = useState({
    pasFoto: null,
    fotoKK: null,
    fotoRapor: null,
    ijazah: null,
    piagam: null,
  });

  const [previews, setPreviews] = useState({
    pasFoto: "",
    fotoKK: "",
    fotoRapor: "",
    ijazah: "",
    piagam: "",
  });

  const [uploadProgress, setUploadProgress] = useState({
    pasFoto: 0,
    fotoKK: 0,
    fotoRapor: 0,
    ijazah: 0,
    piagam: 0,
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  // 🔒 HANYA ANGKA
  const handleNumberOnly = (e) => {
    const { name, value } = e.target;
    if (/^[0-9]*$/.test(value)) {
      setForm({ ...form, [name]: value });
    }
  };

  // 🔒 ANGKA + DESIMAL
  const handleDecimal = (e) => {
    const { name, value } = e.target;
    if (/^[0-9]*\.?[0-9]*$/.test(value)) {
      setForm({ ...form, [name]: value });
    }
  };

  const handleFile = (e) => {
    const { name, files: selected } = e.target;
    if (!selected.length) return;

    const file = selected[0];
    setFiles({ ...files, [name]: file });

    if (file.type.startsWith("image/")) {
      const reader = new FileReader();
      reader.onload = () =>
        setPreviews({ ...previews, [name]: reader.result });
      reader.readAsDataURL(file);
    } else if (file.type === "application/pdf") {
      setPreviews({ ...previews, [name]: URL.createObjectURL(file) });
    }
  };
  // 🔥 FITUR HAPUS / GANTI FILE
  const handleRemoveFile = (key) => {
    setFiles((prev) => ({ ...prev, [key]: null }));
    setPreviews((prev) => ({ ...prev, [key]: "" }));
    setUploadProgress((prev) => ({ ...prev, [key]: 0 }));
  };


  const compressImageIfNeeded = async (file) => {
    if (!file.type.startsWith("image/")) return file;
    return await imageCompression(file, {
      maxSizeMB: 1,
      maxWidthOrHeight: 1920,
      useWebWorker: true,
    });
  };

  const uploadToCloudinary = (file, onProgress) =>
    new Promise(async (resolve, reject) => {
      try {
        const cloudName = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME;
        const preset = process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET;

        let uploadFile = file;
        if (file.type.startsWith("image/")) {
          uploadFile = await compressImageIfNeeded(file);
        }

        const xhr = new XMLHttpRequest();
        xhr.open("POST", `https://api.cloudinary.com/v1_1/${cloudName}/upload`);

        const formData = new FormData();
        formData.append("file", uploadFile);
        formData.append("upload_preset", preset);

        xhr.upload.onprogress = (e) => {
          if (e.lengthComputable) {
            onProgress(Math.round((e.loaded / e.total) * 100));
          }
        };

        xhr.onload = () => {
          const res = JSON.parse(xhr.responseText);
          resolve(res.secure_url);
        };

        xhr.onerror = () => reject(new Error("Upload gagal"));
        xhr.send(formData);
      } catch (err) {
        reject(err);
      }
    });

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!files.pasFoto || !files.fotoKK || !files.fotoRapor || !files.ijazah) {
      Swal.fire("Peringatan", "File wajib belum lengkap!", "warning");
      return;
    }

    const confirm = await Swal.fire({
      title: "Yakin kirim data?",
      icon: "question",
      showCancelButton: true,
    });
    if (!confirm.isConfirmed) return;

    setLoading(true);

    const fileKeys = Object.keys(files).filter((k) => files[k]);
    const totalFiles = fileKeys.length;

    Swal.fire({
      title: "Mengupload Berkas",
      html: `<b>0/${totalFiles}</b><br/><div id="progressText">0%</div>`,
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading(),
    });

    try {
      const urls = {};
      let currentIndex = 0;

      for (const key of fileKeys) {
        currentIndex++;

        urls[key] = await uploadToCloudinary(files[key], (percent) => {
          const overall =
            Math.round(
              ((currentIndex - 1 + percent / 100) / totalFiles) * 100
            );

          Swal.update({
            html: `<b>${currentIndex}/${totalFiles}</b><br/>
                   ${key}<br/>
                   ${overall}%`,
          });
        });
      }

      await addDoc(collection(db, "ppdb"), {
        uid: auth.currentUser.uid,
        email: auth.currentUser.email,
        ...form,
        ...urls,
        status: "Menunggu",
        tanggal_daftar: Timestamp.now(),
      });

      Swal.fire("Sukses", "Pendaftaran berhasil!", "success");
      navigate("/status-ppdb");
    } catch (err) {
      Swal.fire("Error", err.message, "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container py-5">
      <h2 className="text-center mb-4 text-primary fw-bold">Formulir Pendaftaran PPDB Online</h2>

      <form
        onSubmit={handleSubmit}
        className="p-4 shadow-lg rounded-4"
        style={{ background: "linear-gradient(135deg, #f0f8ff, #e0f7ff)" }}
      >
        {/* Semua input tetap sama */}
        {/* DATA DIRI */}
        <div className="mb-3 input-group">
          <span className="input-group-text bg-primary text-white"><FaUser /></span>
          <input type="text" name="nama" placeholder="Nama Lengkap" className="form-control" value={form.nama} onChange={handleChange} required />
        </div>
        <div className="mb-3 input-group">
          <span className="input-group-text bg-primary text-white"><FaIdCard /></span>
          <input type="text" name="nisn" placeholder="NISN" className="form-control" value={form.nisn} onChange={handleChange} required />
        </div>
        <div className="row g-2 mb-3">
          <div className="col-md-6 input-group">
            <span className="input-group-text bg-primary text-white"><FaSchool /></span>
            <input type="text" name="tempat_lahir" placeholder="Tempat Lahir" className="form-control" value={form.tempat_lahir} onChange={handleChange} required />
          </div>
          <div className="col-md-6 input-group">
            <span className="input-group-text bg-primary text-white"><FaCalendarAlt /></span>
            <input type="date" name="tanggal_lahir" className="form-control" value={form.tanggal_lahir} onChange={handleChange} required />
          </div>
        </div>
        <select className="form-select mb-3" name="jenis_kelamin" value={form.jenis_kelamin} onChange={handleChange} required>
          <option value="">-- Pilih Jenis Kelamin --</option>
          <option value="Laki-laki">Laki-laki</option>
          <option value="Perempuan">Perempuan</option>
        </select>
        <input className="form-control mb-3" name="asal_sekolah" placeholder="Asal Sekolah" value={form.asal_sekolah} onChange={handleChange} required />
        <textarea className="form-control mb-3" name="alamat" placeholder="Alamat Lengkap" value={form.alamat} onChange={handleChange} required />
        <div className="input-group mb-3">
          <span className="input-group-text"><FaPhone /></span>
          <input name="telepon" className="form-control" placeholder="No Telepon"
            value={form.telepon}
            onChange={handleNumberOnly}
            inputMode="numeric"
            maxLength={13}
            required />
        </div>

        <input className="form-control mb-3" name="nilai_rata"
          placeholder="Nilai Rata-rata"
          value={form.nilai_rata}
          onChange={handleDecimal}
          required />
          
        {/* DATA ORANG TUA */}
        <h5 className="mt-4 fw-bold">Data Orang Tua</h5>
        <input className="form-control mb-2" name="nama_ayah" placeholder="Nama Ayah" value={form.nama_ayah} onChange={handleChange} required />
        <input className="form-control mb-2" name="nama_ibu" placeholder="Nama Ibu" value={form.nama_ibu} onChange={handleChange} required />
        <input className="form-control mb-2" name="pekerjaan_ayah" placeholder="Pekerjaan Ayah" value={form.pekerjaan_ayah} onChange={handleChange} required />
        <input className="form-control mb-2" name="pekerjaan_ibu" placeholder="Pekerjaan Ibu" value={form.pekerjaan_ibu} onChange={handleChange} required />
        <input className="form-control mb-3" name="pendidikan_ayah" placeholder="Pendidikan Terakhir Ayah" value={form.pendidikan_ayah} onChange={handleChange} required />
        <input className="form-control mb-3" name="pendidikan_ibu" placeholder="Pendidikan Terakhir Ibu" value={form.pendidikan_ibu} onChange={handleChange} required />

        {/* UPLOAD FILE */}
        {[
          { key: "pasFoto", label: "Pas Foto (JPG/PNG/PDF)" },
          { key: "fotoKK", label: "Foto/Scan Kartu Keluarga (JPG/PNG/PDF)" },
          { key: "fotoRapor", label: "Foto/Scan Rapor (JPG/PNG/PDF)" },
          { key: "ijazah", label: "Ijazah (JPG/PNG/PDF)" },
          { key: "piagam", label: "Piagam Penghargaan (Opsional)" },
        ].map((f) => (
          <div className="mb-3" key={f.key}>
            <label className="form-label d-flex align-items-center">
              <FaUpload className="me-2 text-primary" />
              {f.label}
            </label>

            <input
              type="file"
              className="form-control"
              accept="image/*,application/pdf"
              name={f.key}
              onChange={handleFile}
              required={f.key !== "piagam"}
            />
{files[f.key]?.type?.startsWith("image/") && previews[f.key] && (
  <div className="mt-2 d-flex align-items-start gap-3">
    <img
      src={previews[f.key]}
      width={120}
      className="rounded border"
      alt="preview"
    />

    <div style={{ flex: 1 }}>
      <div className="small text-muted mb-1">Preview gambar</div>

      <div className="progress mb-2" style={{ height: "8px" }}>
        <div
          className="progress-bar"
          role="progressbar"
          style={{ width: `${uploadProgress[f.key]}%` }}
          aria-valuenow={uploadProgress[f.key]}
          aria-valuemin="0"
          aria-valuemax="100"
        >
          {uploadProgress[f.key]}%
        </div>
      </div>

      <button
        type="button"
        className="btn btn-sm btn-danger"
        onClick={() => handleRemoveFile(f.key)}
      >
        <FaTrash className="me-1" />
        Hapus 
      </button>
    </div>
  </div>
)}


            {/* Preview untuk PDF */}
            {previews[f.key] && files[f.key]?.type === "application/pdf" && (
              <div className="mt-2">
                <div className="d-flex align-items-center text-danger fw-bold mb-2">
                  <FaFilePdf size={28} className="me-2" />
                  <span>{files[f.key]?.name}</span>
                </div>

                {/* PDF viewer (iframe). Jika ingin download, klik kanan frame. */}
                <div style={{ height: 300 }} className="border rounded overflow-hidden">
                  <iframe
                    src={previews[f.key]}
                    title={f.key}
                    style={{ width: "100%", height: "100%", border: "none" }}
                  />
                </div>

                <div className="progress mt-2" style={{ height: "8px" }}>
                  <div
                    className="progress-bar"
                    role="progressbar"
                    style={{ width: `${uploadProgress[f.key]}%` }}
                    aria-valuenow={uploadProgress[f.key]}
                    aria-valuemin="0"
                    aria-valuemax="100"
                  >
                    {uploadProgress[f.key]}%
                  </div>
                </div>
              </div>
            )}

            {/* Jika file bukan pdf dan bukan image (rare), tampil nama file */}
            {!files[f.key] && <div className="form-text">Belum ada file</div>}
          </div>
        ))}

        <button type="submit" className="btn btn-gradient w-100 py-2 mt-3" disabled={loading}>
          {loading ? "Mengirim..." : "Kirim Pendaftaran"}
        </button>
      </form>

      <style>{`
        .btn-gradient {
          background: linear-gradient(45deg, #007bff, #00c6ff);
          color: white;
          font-weight: 600;
          transition: transform 0.2s, box-shadow 0.2s;
        }
        .btn-gradient:hover {
          transform: translateY(-3px);
          box-shadow: 0 8px 20px rgba(0,123,255,0.4);
        }
      `}</style>
    </div>
  );
}
